// Hook odpowiedzialny za pobranie listy dostaw na dashboardzie

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  IStatus
} from 'api/types';

export interface IDashboardDeliveryListItem {
  currency: string;
  delivery_date: string;
  delivery_method_icon_image_url: string;
  delivery_method_id: number;
  delivery_method_name: string;
  id: number;
  manual_cash_on_delivery_value: number;
  order_id: number;
  shipping_date: string;
  status: IStatus;
  status_message: string;
  status_type: number;
  symbol: string;
  tracking_number: string;
  tracking_url: string;
  value: number;
  value_formatted: string;
}

// parametry requestu do api
export type IRequest = IPaginationRequest;

// typ zwracanych danych
type IResponse = IPaginationResponse<IDashboardDeliveryListItem>;

const getDashboardDeliveries = (params?: IRequest): Promise<IResponse> =>
  axios.get('dashboards/deliveries', { params });

export const useGetDashboardDeliveries = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['dashboard-deliveries', params],
    () => getDashboardDeliveries(params),
    options
  );
